import "./App.scss";

import {createBrowserRouter, createRoutesFromElements, Route,} from "react-router-dom";
import {HomePage} from "./pages/home/HomePage";
import {AuthLayout} from "./layouts/AuthLayout";
import {HomeLayout} from "./layouts/HomeLayout";
import {ProtectedLayout} from "./layouts/ProtectedLayout";
import {ApplicationsPage} from "./pages/applications/ApplicationsPage";
import {UsersPage} from "./pages/users/UsersPage";
import {ApplicationDetailPage} from "./pages/application-detail/ApplicationDetailPage";
import {Sidebar} from "./components/sidebar/Sidebar";
import {SignInPage} from "./pages/auth/SignInPage";
import {SignUpPage} from "./pages/auth/SignUpPage";
import {PlansPage} from "./pages/plans/PlansPage";
import {DashboardPage} from "./pages/dashboard/DashboardPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AccountVerification from "./pages/auth/AccountVerification";
import UserVerification from "./pages/auth/UserVerification";
import {SettingsPage} from "./pages/settings/SettingsPage";
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

const user = JSON.parse(window.localStorage.getItem("user"));

function fetchUser() {
    return Promise.resolve(user);
}

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<AuthLayout/>} loader={fetchUser}>
            <Route element={<HomeLayout/>}>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/features" element={<HomePage scrollTo="features-section" />}/>
                <Route path="/pricing" element={<HomePage scrollTo="pricing-section" />}/>
                <Route path="/contact" element={<HomePage scrollTo="contact-section" />}/>
                <Route path="/login" element={<SignInPage/>}/>
                <Route path="/register" element={<SignUpPage/>}/>
                <Route path="/forgot-password" element={<ForgotPassword/>}/>
                <Route path="/reset-password" element={<ResetPassword/>}/>
                <Route path="/verify-user/:id/:hash" element={<UserVerification />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            </Route>

            <Route
                path="/app"
                element={<ProtectedLayout sidebar={<Sidebar user={user}/>}/>}
            >
                <Route path="dashboard" element={<DashboardPage/>}/>
                <Route path="applications">
                    <Route index element={<ApplicationsPage/>}/>
                    <Route path=":applicationId" element={<ApplicationDetailPage/>}/>
                </Route>
                <Route path="users" element={<UsersPage/>}/>
                <Route path="plans" element={<PlansPage/>}/>
                <Route path="settings" element={<SettingsPage/>}/>
                <Route path="verify-account/:id/:hash" element={<AccountVerification />} />
            </Route>
        </Route>
    )
);

export {router};
